var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tt-button p-404__button p-404__button--width_auto",attrs:{"href":_vm.linkGenerator()}},[_c('p',{staticClass:"tt-button__title"},[_vm._v(_vm._s(_vm._('ПОВЫСИТЬ УРОВЕНЬ')))])])}
var staticRenderFns = []

export { render, staticRenderFns }